import { useEffect } from 'react';
import { useWidgetDetails } from 'worker-connection-library/hooks/useWidgetDetails';
import { getLiveRecommendations } from 'calling-cross-tab-library/appData/operators/activeCallDetailsOperators';
import { getActiveCallDetails } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { Metrics, OPEN_REMOTE } from 'calling-remote-common/utils/Metrics';
export const useOpenRemoteOnLiveRecommendation = openRemote => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const activeCallDetails = getActiveCallDetails(widgetDetails);
  const liveRecommendations = getLiveRecommendations(activeCallDetails);
  useEffect(() => {
    // open any time the length of liveRecommendations changes and is greater than 0
    if (liveRecommendations.length > 0) {
      openRemote();
      Metrics.counter(OPEN_REMOTE, {
        source: 'live-recommendation'
      }).increment();
    }
  }, [liveRecommendations.length, openRemote]);
};